export default "__VITE_ASSET__mUyrdodh__"